import React from 'react';

import cx from 'classnames';

import SVG from '../../atoms/SVG';
import { IAlertProps } from './interfaces';

const Alert: React.FC<IAlertProps> = ({
  children,
  className = '',
  colorClassName = 'bg-grey-lightest text-grey-dark border-grey-lighter',
  icon = '',
  iconTitle,
  iconClassName,
  ...props
}) => {
  const classes = cx(
    'Alert',
    'border px-4 py-3 rounded leading-loose text-micro font-medium items-center justify-start whitespace-pre-wrap',
    className,
    colorClassName,
    { flex: !!icon }
  );

  return (
    <div data-testid="alert" className={classes} {...props}>
      {icon && <SVG src={icon} title={iconTitle} className={cx('flex mr-2', iconClassName)} />}
      {children}
    </div>
  );
};

export default Alert;
